import { formatDateForMaistra } from '../../utils-common'
import CldImg from '../components/CldImg'

export default {
  name: 'Card',
  components: { CldImg },
  template: `
<div class="card" :class="card.class">
  <div v-if="card.image" class="card__image">
    <a :href="card.link" :title="card.title">
      <CldImg :src="card.image" :alt="card.title" />
    </a>
  </div>

  <div v-if="card.tags || (card.expirydate && ! card.startdate) || travelType" class="card__tags">
    <span v-for="tag in card.tags">{{ tag }}</span>
    <span v-if="card.expirydate">{{ $t('until') }} {{ formatDateForMaistra(new Date(card.expirydate)) }}</span>
    <span v-if="travelType">{{ travelType }}</span>
  </div>

  <div v-if="card.title">
    <a class="h3" :href="card.link">{{ card.title }}</a>
  </div>

  <div v-if="card.location" class="card__location">{{ card.location }}</div>

  <template v-if="card.startdate && card.expirydate">
    <p v-if="isOneDayEvent()">{{ formatDateForMaistra(card.startdate) }}</p>
    <p v-else>{{ formatDateForMaistra(card.startdate) }} - {{ formatDateForMaistra(card.expirydate) }}</p>
  </template>

  <div v-if="showDescription" class="card__description">
    <p>{{ card.description }}</p>
  </div>

  <a :href="card.link" class="button button--outline">{{ $t('discoverMore') }}</a>
</div>
  `,
  props: { card: Object, showDescription: Boolean, travelType: String },
  setup (props) {
    function isOneDayEvent () {
      if (props.card.startdate && props.card.expirydate) {
        const start = props.card.startdate?.toLocaleString('de-DE').split(',')[0]
        const end = props.card.expirydate?.toLocaleString('de-DE').split(',')[0]
        return start === end
      }
      return false
    }

    return {
      isOneDayEvent,
      formatDateForMaistra,
    }
  },
}
